import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { fromEvent } from 'rxjs';
import { filter, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNContactType } from 'src/app/models/cncontacttype';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import { CNServiceCodeGroup } from 'src/app/models/cnservicecodegroup';
import { PatientService } from 'src/app/services/patient.service';
import { ServicesService } from 'src/app/services/services.service';
import { UserConfigService } from 'src/app/services/user-config.service';

@ManageType('ContactServicesPanelComponent')
@Component({
  selector: 'app-contact-services-panel',
  templateUrl: './contact-services-panel.component.html',
  styleUrls: ['./contact-services-panel.component.scss']
})
export class ContactServicesPanelComponent implements OnInit {

  public groups: CNServiceCodeGroup[];
  public isSearching = false;
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @Output() action: EventEmitter<[action: string, code: CNServiceCode | CNServiceCode[]]> = new EventEmitter();

  private allGroups: CNServiceCodeGroup[];

  constructor(private patient: PatientService, public services: ServicesService,
              public userConfig: UserConfigService) { }

  ngOnInit(): void {
    this.services.groups.subscribe(groups => {
      this.allGroups = groups;
      this.groups = groups;
    });
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(300)
      , distinctUntilChanged()
      // subscription for response
    ).subscribe((text: string) => {
      if (text.length === 0) {
        this.groups = this.allGroups;
      } else {
        this.isSearching = true;
        this.groups = [];
        this.allGroups.forEach(group => {
          const copyGroup: CNServiceCodeGroup = group.copy();
          copyGroup.codes = group.codes.filter(code => (code.code) ? code.code.includes(text) : code.value.includes(text));
          this.groups.push(copyGroup);
        });
        this.isSearching = false;
      }
    }, (err) => {
      this.isSearching = false;
      console.log('error', err);
    });
  }

  codeAction(action: [string, CNServiceCode]): void {
    this.action.emit(action);
  }

  selectType(type: CNContactType): void {
    this.action.emit(['add', type.codes]);
  }
}
